module.exports = __webpack_public_path__ + "img/7.c3a521a2.png";